import {isNZ} from "@/scripts/util/countryCheck"

const SUMMARY_PAGE_INPUT_SELECTORS = {

    // Summary : Step 1 Input Selectors
    applicationFirstName: `#first_name`,
    applicationMiddleName: `#middle_name`,
    applicationLastName: `#last_name`,
    applicationPhone: `[name="phone"]`,
    applicationPhoneMask: `[name="phone_mask"]`,
    applicationEmail: `[name="email"]`,
    applicationHasDealer: `[name="application_has_dealer"]`,
    applicationDealerName: `#dealer_name`,
    applicationDealerRep: `#dealer_rep`,
    applicationAddress: `#street_address`,
    applicationAddressLine2: `#street_address_line_2`,
    applicationAddressCity: `[name="city_suburb"]`,
    applicationAddressZip: `#zip`,
    applicationAddressState: `#state`,

    // Summary : Step 2 Input Selectors
    applicationCustomerGender: `#Web_App_Gender__c`,
    applicationSubmittedBirthday: `#date_of_birth`,
    applicationFormattedBirthday: `#formatted_date_of_birth`,
    applicationMedicareNameOnCard: `[name="Web_App_Medicare_Name_On_Card__c"]`,
    applicationMedicareNumber: `[name="medicare_card_number"]`,
    applicationMedicareColor: `[name="medicare_card_colour"]`,
    applicationmedicarePosition: `[name="medicare_card_position"]`,
    applicationmedicareExpiryYear: `[name="medicare_card_expiry_year"]`,
    applicationmedicareExpiryMonth: `[name="medicare_card_expiry_month"]`,
    applicationDriversLicense: `[name="drivers_licence_number"]`,
    applicationDriversLicenseCardNumber: `[name="drivers_licence_card_number"]`,
    applicationDriversLicenseVersion: `[name="drivers_license_version"]`,
    applicationStateIssue: `[data-issue-license]`,

    // Summary : Step 3 Input Selectors
    applicationTradingName: `[name="trading_name"]`,
    applicationPrivateLegalName: `[name="private_legal_name"]`, // NZ Specific
    applicationLegalName: `[name="legal_name"]`, // NZ API = Entity Type
    ABNInput: `#ABNFinder`,
    ABNTextSearchInput: `#ABNTextSearchInput`,
    ABNTextSearchButton: `#ABNTextFinderButton`,
    ABNResultWrapper: `[data-results-abn]`,
    hiddenBusinessNumberInputField: isNZ()
        ? `[name="nzbn"]`
        : `[name="abn"]`,
    confirmationBoxBusinessNumberValue: `[data-business-number]`,
    confirmationBoxIsLegalNameValue: `[data-name-type]`,
    confirmationBoxLegalNameValue: `[data-business-name]`,
    incorporationNumber: `[name="business_number"]`,

    // Toggle (Copy Functionality)
    businessToggleCheckbox: `[name="business-address"]`,
    applicationBusinessAddress: `[name="business_street_address"]`,
    applicationBusinessAddressLine2: `[name="business_street_address_line_2"]`,
    applicationBusinessCity: `[name="business_city"]`,
    applicationBusinessPostcode: `[name="business_postcode"]`,
    applicationBusinessState: `[name="business_state"]`,

}

const SUMMARY_PAGE_OUTPUT_SELECTORS = {

    // Summary : Step 1 Selectors (Personal & Contact Details)
    appValueName: `[data-application-name]`,
    appValueBirthday: `[data-birthday]`,
    appValuePhone: `[data-application-phone]`,
    appValueEmail: `[data-application-email]`,
    appValueAddress: `[data-address]`,
    appValueCustomerGender: `[data-customer-gender]`,
    appValueHasDealer: `[data-has-dealership]`,
    appValueDealerName: `[data-dealership-name]`,
    appValueDealerRep: `[data-dealership-rep]`,

    // Summary : Step 2 Output selectors (Business Verification)
    appValueIncorporation: `[data-incorporation-number]`,
    appValueTradingName: `#business-trading-name`,
    appValueLegalName: `#business-legal-name`,
    appValuePrivateLegalName: `#business-private-legal-name`,
    appValueABNnumber: `[data-abn-number]`,
    appValueNatureBusiness: `[data-nature-business]`,
    appValueBusinessAddress: `[data-business-address]`,

    // Summary : Step 3 Output Selectors (Personal ID Verification)
    appValueMedicareNameOnCard: `[data-medicare-name-on-card]`,
    appValueMedicareNumber: `[data-medicare-number]`,
    appValueMedicareColor: `[data-medicare-color]`,
    appValueMedicarePosition: `[data-medicare-position]`,
    appValueMedicareExpiry: `[data-medicare-expiry]`,
    appValueDriversLicense: `[data-drivers-license]`,
    appValueDriversLicenseCardNumber: `[data-licence-card-number]`,
    appValueDriversLicenseVersion: `[data-drivers-license-version]`,
    appValueStateIssue: `[data-state-issue]`,
}

const getSelectors = object => {
    const selectors = {}

    Object.entries(object).forEach(([key, value]) => {
        const element = document.querySelector(value)

        if (element) {
            selectors[key] = element
        }
    })
    return selectors
}

const getSummaryPageSelectors = () => {
    return getSelectors(SUMMARY_PAGE_OUTPUT_SELECTORS)
}

const getApplicationFormSelectors = () => {
    return getSelectors(SUMMARY_PAGE_INPUT_SELECTORS)
}

export {getSummaryPageSelectors, getApplicationFormSelectors}
